import { useQuery } from "@tanstack/react-query"

import { CurrenciesService } from "../generated"

export const useCurrencies = () => useQuery(["currencies"], () => CurrenciesService.currenciesGetAllAsync({}))

export const useCurrency = (id: UUID) =>
  useQuery(["currencies", id], () => CurrenciesService.currenciesGetAsync({ id }))
